import { render, staticRenderFns } from "./MoleculeFeedProductsContentModalCreate.vue?vue&type=template&id=520967fb&"
import script from "./MoleculeFeedProductsContentModalCreate.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedProductsContentModalCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports